import { useState, useEffect } from 'react';
import { settlementApi } from '../../lib/api';

export default function HostEarningsPage() {
  const [splits, setSplits] = useState<any[]>([]);
  const [totals, setTotals] = useState({ pending: 0, settled: 0 });

  useEffect(() => {
    Promise.all([
      settlementApi.list(),
      settlementApi.total(),
    ]).then(([splitsRes, totalsRes]: any[]) => {
      setSplits(splitsRes.splits || []);
      setTotals(totalsRes || { pending: 0, settled: 0 });
    }).catch(() => {});
  }, []);

  const formatPrice = (won: number) => new Intl.NumberFormat('ko-KR').format(won) + '원';

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">수익 현황</h1>
      <div className="grid grid-cols-2 gap-4 mb-8">
        <div className="card p- overflow-x-auto5">
          <p className="text-sm text-gray-500">정산 예정</p>
          <p className="text-2xl font-bold text-yellow-600">{formatPrice(totals.pending)}</p>
        </div>
        <div className="card p- overflow-x-auto5">
          <p className="text-sm text-gray-500">정산 완료</p>
          <p className="text-2xl font-bold text-green-600">{formatPrice(totals.settled)}</p>
        </div>
      </div>
      {splits.length === 0 ? (
        <div className="card p- overflow-x-auto8 text-center text-gray-400">아직 정산 내역이 없습니다</div>
      ) : (
        <div className="card divide-y divide-gray-100">
          {splits.map((s: any) => (
            <div key={s.id} className="p-4 flex justify-between items-center text-sm">
              <div>
                <p className="font-medium">{s.make} {s.model}</p>
                <p className="text-gray-500">{s.pickup_date} ~ {s.return_date}</p>
              </div>
              <div className="text-right">
                <p className="font-semibold">{formatPrice(s.amount)}</p>
                <span className={`badge text-xs ${s.status === 'settled' ? 'badge-green' : 'badge-yellow'}`}>
                  {s.status === 'settled' ? '정산완료' : '대기중'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
